import { render } from "./Courier.vue?vue&type=template&id=62650c5a"
import script from "./Courier.vue?vue&type=script&lang=js"
export * from "./Courier.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__